export default "<div class=\"container\">\r\n  <header>\r\n    <h3>Página no encontrada</h3>\r\n  </header>\r\n</div>\r\n"